import { List, ListItem, ListItemText } from "@mui/material";
import { GREY } from "@/config/mui/colorPalette";
import { SelectedService } from "./selectedService";
import { SortableServices } from "./sortableServices";
import { Service } from "./types";

type Props = {
  services: Service[];
  onRemoveService: (index: number) => void;
  onReorderServices: (sourceIndex: number, destinationIndex: number) => void;
  onEditProvider: (index: number) => void;
};

export const SelectedServicesList = ({
  services,
  onRemoveService,
  onReorderServices,
  onEditProvider,
}: Props) => {
  if (services.length === 0) return <EmptyState />;

  if (services.length === 1) {
    return (
      <List sx={{ p: 0 }}>
        <SelectedService
          service={services[0].serviceMenuItem}
          provider={services[0].provider}
          onRemove={() => {
            onRemoveService(0);
          }}
          onEditProvider={() => {
            onEditProvider(0);
          }}
        />
      </List>
    );
  }

  return (
    <SortableServices
      services={services}
      onRemoveService={onRemoveService}
      onReorderServices={onReorderServices}
      onEditProvider={onEditProvider}
    />
  );
};

const EmptyState = () => (
  <List sx={{ p: 0, mb: 1.5 }}>
    <ListItem
      sx={{
        backgroundColor: GREY[5],
        borderRadius: 2,
        gap: 2,
      }}
    >
      <ListItemText
        primary="No services added yet"
        slotProps={{
          primary: {
            variant: "labelSmall",
            color: "text.secondary",
            textAlign: "center",
          },
        }}
      />
    </ListItem>
  </List>
);
